import styled from 'styled-components';

export const FlexJustifyCenter = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  @media (max-width: 800px) {
    flex-direction: column;
  }
`;

export const Tab = styled.div`
  color: ${(props) => props.theme.colors.neutral0};
  padding: 10px;
  border-radius: 12px;
  background: ${(props) => props.theme.colors.error500};
  font-size: 12px;
  margin: 0 5px 8px 5px;
  cursor: pointer;
`;

export const Desktop = styled.div`
  display: block;
  @media (max-width: 1000px) {
    display: none;
  }
`;

export const Mobile = styled.div`
  display: none;
  @media (max-width: 1000px) {
    display: block;
  }
`;

export const Circle = styled.div`
  width: 50px;
  height: 50px;
  background: ${(props) => props.color};
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 30px;
`;
